module.exports = __webpack_public_path__ + "static/media/7-1.e066cae7.webp";